module.exports = __webpack_public_path__ + "img/07c777984388a5ef3a9ca1ad13aedae.84d63ef8.png";